import React from 'react';
import { Eye, Compass, Sparkles, Rocket, Check, Building2, ShoppingBag, Wrench, Heart, Factory, UtensilsCrossed, Truck, Wheat } from 'lucide-react';

const phaseIcons = { eye: Eye, compass: Compass, sparkles: Sparkles, rocket: Rocket };
const phaseColors = ['#6366f1', '#f59e0b', '#10b981', '#ef4444'];
const industryIcons = [ShoppingBag, Wrench, Building2, Heart, Factory, UtensilsCrossed, Truck, Wheat];

const Services = ({ t }) => {
  const { phases, industries } = t.services;

  return (
    <section id="services" className="services-section">
      <div className="container">
        <div className="section-header">
          <h2 className="heading-1">{t.services.title}</h2>
          <p className="body-large text-secondary">{t.services.subtitle}</p>
        </div>

        {/* Phase Cards */}
        <div className="phases-grid">
          {(Array.isArray(phases) ? phases : []).map((phase, i) => {
            const Icon = phaseIcons[phase.icon];
            const color = phaseColors[i];
            return (
              <div key={i} className="phase-card" data-testid={`phase-card-${i}`}>
                <div className="phase-number" style={{ background: color }}>{String(i + 1).padStart(2, '0')}</div>
                <div className="phase-icon-wrap" style={{ background: `${color}14` }}>
                  <Icon size={28} style={{ color }} />
                </div>
                <h3 className="phase-title">{phase.title}</h3>
                <p className="phase-tagline" style={{ color }}>{phase.tagline}</p>
                <p className="phase-description">{phase.description}</p>
                <ul className="phase-benefits">
                  {(Array.isArray(phase.benefits) ? phase.benefits : []).map((b, j) => (
                    <li key={j}>
                      <Check size={15} style={{ color, flexShrink: 0, marginTop: 2 }} />
                      <span>{b}</span>
                    </li>
                  ))}
                </ul>
              </div>
            );
          })}
        </div>

        {/* Connector line (visual only) */}
        <div className="phase-connector" aria-hidden="true">
          {(Array.isArray(phaseColors) ? phaseColors : []).map((c, i) => (
            <div key={i} className="connector-dot" style={{ background: c }} />
          ))}
        </div>

        {/* Industries Section */}
        <div className="industries-block" data-testid="industries-section">
          <h3 className="industries-title">{industries.title}</h3>
          <p className="body-medium text-secondary" style={{ textAlign: 'center', marginBottom: 32 }}>
            {industries.subtitle}
          </p>
          <div className="industries-grid">
            {(Array.isArray(industries.items) ? industries.items : []).map((ind, i) => {
              const IndIcon = industryIcons[i];
              return (
                <div key={i} className="industry-chip" data-testid={`industry-${i}`}>
                  <IndIcon size={18} style={{ color: phaseColors[i % phaseColors.length], flexShrink: 0 }} />
                  <div>
                    <span className="industry-name">{ind.name}</span>
                    <span className="industry-example">{ind.example}</span>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Services;
